export const MAX_CONTENT_WIDTH = '1200px';
export const BORDER_RADIUS = '2px';

// Spacing — semantic names, consistent density values
export const SPACING_MICRO = '2px';           // hairline adjustments
export const SPACING_TIGHT = '4px';           // between tightly grouped elements
export const SPACING_ELEMENT = '6px';         // between related elements (label to input, icon to text)
export const SPACING_COMPACT = '8px';         // compact component padding, icon gaps
export const SPACING_COMPONENT = '10px';      // standard component inner padding
export const SPACING_BUTTON = '12px';         // button/form element padding
export const SPACING_CARD = '16px';           // card inner padding, grid gaps
export const SPACING_CARD_BODY = '20px';      // card body / content area padding
export const SPACING_GROUP = '24px';          // between groups of content
export const SPACING_SECTION = '32px';        // between major page sections
export const SPACING_SECTION_LARGE = '40px';  // large section breaks
export const SPACING_HERO = '48px';           // hero / featured section padding
export const SPACING_PAGE = '60px';           // top-level page vertical padding
export const SPACING_PAGE_LARGE = '80px';     // full-width section vertical padding
